<style lang="scss">
  .booksContent {
    overflow: hidden;
    .books {
      position: relative;
      z-index: 2;
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      grid-gap: 50px;
    }
    .showMoreBtn {
      display: block;
      width: 100%;
      margin: 50px 0;
    }
    @media (min-width: 576px) {
      .books {
        grid-template-columns: repeat(2, 1fr);
      }
    }
    @media (min-width: 992px) {
      .books {
        grid-template-columns: repeat(4, 1fr);
      }
    }
  }
</style>
<template>
  <div class="booksContent">
    <FrontendNav></FrontendNav>
    <div class="container">
      <header>
        <h2>{{title}}</h2>
      </header>
      <ul class="books">
        <li v-for="book in books" :key="book.id">
          <FrontendBooklink
            :button="true"
            :book="book"
          ></FrontendBooklink>
        </li>
      </ul>
    </div>
    <FrontendFooter></FrontendFooter>
  </div>
</template>

<script>
import FrontendNav from '../partials/nav'
import FrontendFooter from '../partials/footer'
import FrontendBooklistHeader from '../partials/booklistheader'
import FrontendBooklink from '../partials/booklink'

export default {
  name: 'BookSearch',
  components: {
    FrontendNav,
    FrontendFooter,
    FrontendBooklink,
    FrontendBooklistHeader
  },
  computed: {
    url: function () {
      return process.env.API_URL + '/' + process.env.API_ENDPOINT
    },
    title: function () {
      return this.$route.params.search
    }
  },
  created: function () {
    this.getBooks(this.url + `/book/search/${this.$route.params.search}`)
  },
  methods: {
    getBooks: function (_url, add = false) {
      this.$http
        .get(_url, {
          'headers': {
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (res.data.data.length < this.limit) {
            this.isMoreBtn = false
          } else {
            this.isMoreBtn = true
          }
          if (add) {
            for (let item in res.data.data) {
              this.books.push(res.data.data[item])
            }
          } else {
            this.books = res.data.data
          }
        }).catch(res => {
        })
    }
  },
  data: function () {
    return {
      catName: 'Összes',
      catUrl: '',
      activeCat: '/konyvek',
      catOrder: true,
      categories: [],
      books: [],
      fbhKey: 0,
      limit: 16,
      offset: 0,
      isMoreBtn: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frontend/search/BookSearch.vue